var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPremium(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "19px",
    viewBox: "0 0 23 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPremium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.099807,469.612223 C208.12043,469.612223 207.288403,470.403866 207.288403,471.442968 C207.288403,471.788962 207.386452,472.085688 207.533247,472.333147 L202.882316,477.132834 C201.609902,475.054631 200.777875,471.987153 200.336934,469.958217 C201.022165,469.612223 201.511853,468.919675 201.511853,468.078204 C201.511853,466.940566 200.581778,466 199.455605,466 C198.329987,466 197.399357,466.940566 197.399357,468.078204 C197.399357,468.919675 197.889046,469.612223 198.574277,469.958217 C198.13389,471.987153 197.301309,475.054631 196.028341,477.132834 L191.377963,472.333147 C191.524759,472.085688 191.622808,471.788962 191.622808,471.442968 C191.622808,470.453134 190.839528,469.612223 189.811404,469.612223 C188.78328,469.612223 188,470.403866 188,471.442968 C188,472.432242 188.78328,473.273713 189.811404,473.273713 L193.140066,484.653446 C193.189367,484.851637 193.385464,485 193.629754,485 L205.330204,485 C205.526301,485 205.721844,484.851637 205.819892,484.653446 L209.099807,473.223885 C210.079184,473.223885 210.911765,472.432242 210.911765,471.39314 C210.862464,470.403866 210.079184,469.612223 209.099807,469.612223",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-See-less",
    transform: "translate(-188.000000, -466.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icPremium",
    fill: "#46A5F7",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPremium);
export default __webpack_public_path__ + "static/media/icPremium.f64af57020a5c6a2c12a0ea9d7b28e75.svg";
export { ForwardRef as ReactComponent };